// base state machine
const stateMachine = require('./stateMachine');

// DEFINE INTERACTION NAME
const interactionName = 'interaction--add-to-bag-mobile';

// CONSTANT STATES FOR THE INTERACTION
const STATE_ADD_TO_BAG_MOBILE = {
  DISABLED: 'state-add-to-bag-mobile-disabled',
  ENABLED: 'state-add-to-bag-mobile-enabled',
  BUSY: 'state-add-to-bag-mobile-busy',
  ADDED: 'state-add-to-bag-mobile-added',
};

// Available states, interaction definition
const states = {
  [STATE_ADD_TO_BAG_MOBILE.DISABLED]: {
    allowed: [STATE_ADD_TO_BAG_MOBILE.ENABLED],
    enter() {},
  },
  [STATE_ADD_TO_BAG_MOBILE.ENABLED]: {
    allowed: [STATE_ADD_TO_BAG_MOBILE.DISABLED, STATE_ADD_TO_BAG_MOBILE.BUSY],
    enter() {},
  },
  [STATE_ADD_TO_BAG_MOBILE.BUSY]: {
    allowed: [
      STATE_ADD_TO_BAG_MOBILE.ENABLED,
      STATE_ADD_TO_BAG_MOBILE.ADDED,
      STATE_ADD_TO_BAG_MOBILE.DISABLED,
    ],
    enter() {},
  },
  [STATE_ADD_TO_BAG_MOBILE.ADDED]: {
    allowed: [STATE_ADD_TO_BAG_MOBILE.ENABLED],
    enter(target) {
      setTimeout(() => {
        $('body').trigger('interaction--add-to-bag-mobile-event', {
          target: $(target),
          state: STATE_ADD_TO_BAG_MOBILE.ENABLED,
        });
      }, 2000);
    },
  },
};

function init(item) {
  stateMachine.init(item, interactionName, states);
}

function destroy() {
  stateMachine.destroy();
}

module.exports = {
  STATE_ADD_TO_BAG_MOBILE,
  init,
  destroy,
};
